import { CyberPanel } from "@/components/ui/CyberPanel";

export function PublicLoading({ label = "Loading content..." }: { label?: string }) {
  return (
    <section className="mx-auto w-full max-w-7xl px-3 py-8 sm:px-6 sm:py-16 lg:px-8">
      <CyberPanel aria-busy="true" role="status">
        <div className="flex items-center gap-3 text-content-secondary">
          <span className="size-2 animate-pulse rounded-full bg-cyan-300 shadow-neon" />
          <p>{label}</p>
        </div>
      </CyberPanel>
    </section>
  );
}

export function PublicError({ label = "Unable to load this content." }: { label?: string }) {
  return (
    <section className="mx-auto w-full max-w-7xl px-3 py-8 sm:px-6 sm:py-16 lg:px-8">
      <CyberPanel role="alert">
        <p className="text-red-100">{label}</p>
      </CyberPanel>
    </section>
  );
}

export function PublicEmpty({ title, description }: { title: string; description: string }) {
  return (
    <section className="mx-auto w-full max-w-7xl px-3 py-8 sm:px-6 sm:py-16 lg:px-8">
      <CyberPanel role="status">
        <h1 className="break-words font-display text-2xl font-bold uppercase text-white sm:text-3xl">{title}</h1>
        <p className="mt-3 text-content-secondary">{description}</p>
      </CyberPanel>
    </section>
  );
}
